/*
 * WELLF reviews — text-swap fade slider (ported from the Claude Design .rev / .prv
 * components). One body element fades and its content (quote / name / verified badge)
 * is swapped from a server-rendered JSON feed. Homepage variant auto-advances (paused
 * on hover/focus, off under prefers-reduced-motion) and has an Expand/Collapse control
 * (highlight <-> full review, verbatim); the product variant is manual-only, no expand.
 * All text is 100% verbatim. No "write a review" UI.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.revReady) return;
    root.dataset.revReady = '1';

    var dataEl = root.querySelector('[data-rev-data]');
    var reviews;
    try { reviews = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!reviews || !reviews.length) return;

    var body = root.querySelector('[data-rev-body]');
    var fadeEls = root.querySelectorAll('[data-rev-fade]');
    if (!fadeEls.length && body) fadeEls = [body];
    var quoteEl = root.querySelector('[data-rev-quote]');
    var nameEl = root.querySelector('[data-rev-name]');
    var numEl = root.querySelector('[data-rev-num]');
    var badgeEl = root.querySelector('[data-rev-badge]');
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    var expandBtn = root.querySelector('[data-rev-expand]');
    var expandLabel = root.querySelector('[data-rev-expand-label]');
    if (!body || !quoteEl || !nameEl) return;

    var expandable = root.dataset.revExpandable === '1';
    var autoplay = parseInt(root.dataset.revAutoplay, 10) || 0;

    var index = 0, expanded = false, animating = false, timer = null, fadeT = null;

    function paint() {
      var r = reviews[index];
      quoteEl.textContent = (expandable && expanded) ? (r.f || r.q) : r.q;
      nameEl.textContent = r.n;
      if (numEl && r.r != null) numEl.textContent = parseFloat(r.r).toFixed(1);
      if (badgeEl) badgeEl.hidden = !r.v;
      if (expandBtn) {
        var hasMore = r.f && r.f !== r.q;
        expandBtn.classList.toggle('is-open', expanded);
        expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expandLabel) expandLabel.textContent = expanded ? 'Collapse' : 'Expand';
        if (expandBtn.parentElement) expandBtn.parentElement.style.visibility = hasMore ? '' : 'hidden';
      }
    }

    function setFade(on) {
      Array.prototype.forEach.call(fadeEls, function (el) { el.classList.toggle('is-fading', on); });
    }

    function fadeSwap(mutate, dur) {
      if (animating) return;
      animating = true;
      setFade(true);
      clearTimeout(fadeT);
      fadeT = setTimeout(function () {
        mutate();
        setFade(false);
        animating = false;
      }, dur);
    }

    function go(dir) {
      fadeSwap(function () {
        index = ((index + dir) % reviews.length + reviews.length) % reviews.length;
        expanded = false;
        paint();
      }, 210);
    }

    function toggle() {
      if (!expandable) return;
      fadeSwap(function () { expanded = !expanded; paint(); }, 170);
    }

    function start() { if (!autoplay || reduce || timer) return; timer = setInterval(function () { if (!expanded) go(1); }, autoplay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
    if (next) next.addEventListener('click', function () { go(1); restart(); });
    if (expandBtn) expandBtn.addEventListener('click', toggle);

    if (autoplay) {
      body.addEventListener('mouseenter', stop);
      body.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    }

    paint();
    start();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wellf-reviews]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
